var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 1.25,
    x2: 14,
    y2: 1.25,
    stroke: "#666666",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 4.25,
    x2: 14,
    y2: 4.25,
    stroke: "#666666",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 7.25,
    x2: 14,
    y2: 7.25,
    stroke: "#666666",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10.25,
    x2: 14,
    y2: 10.25,
    stroke: "#666666",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: 4.25,
    x2: 2,
    y2: 4.25,
    stroke: "#666666",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7.25,
    x2: 2,
    y2: 7.25,
    stroke: "#666666",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.25,
    x2: 2,
    y2: 1.25,
    stroke: "#666666",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: 10.25,
    x2: 2,
    y2: 10.25,
    stroke: "#666666",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListing);
export default __webpack_public_path__ + "static/media/listing.34f9d83e484f6079bc4757bca4adb6b1.svg";
export { ForwardRef as ReactComponent };